<template>
  <div>
    <div class="pt-16 text-2xl font-extrabold">Account Verification</div>
    <div class="pt-3 text-xs px-8">
      We sent you a one-time code by text message for verification purpose. Please kindly enter it below
    </div>
    <div class="pt-8 px-4">
      <div class="grid grid-cols-6 gap-x-3">
        <input type="text" v-model="code[0]" class="border border-nw-ash rounded text-center py-3 focus:outline-none" />
        <input
          type="text"
          v-model="code[1]"
          :readonly="type[1] ? false : true"
          class="border border-nw-ash rounded text-center py-3 focus:outline-none"
        />
        <input
          type="text"
          v-model="code[2]"
          :readonly="type[2] ? false : true"
          class="border border-nw-ash rounded text-center py-3 focus:outline-none"
        />
        <input
          type="text"
          v-model="code[3]"
          :readonly="type[3] ? false : true"
          class="border border-nw-ash rounded text-center py-3 focus:outline-none"
        />
        <input
          type="text"
          v-model="code[4]"
          :readonly="type[4] ? false : true"
          class="border border-nw-ash rounded text-center py-3 focus:outline-none"
        />
        <input
          type="text"
          v-model="code[5]"
          :readonly="type[5] ? false : true"
          class="border border-nw-ash rounded text-center py-3 focus:outline-none"
        />
      </div>
    </div>
    <div class="pt-8 w-1/2 mx-auto text-xs">
      Haven’t received our code? Request a new code in
      <span class="font-bold">00:50</span>
    </div>
    <div class="pt-8 font-extrabold text-gray-400" @click="back">Change Number</div>
    <div class="pt-7 text-xs px-6" @click="signIn">
      <input-button>Verify</input-button>
    </div>
  </div>
</template>

<script>
import fb from '@/services/firebase.js'
import Swal from 'sweetalert2'
import InputButton from './inputs/InputButton.vue'

export default {
  props: {
    verificationId: [String, Object]
  },
  components: { InputButton },
  data() {
    return {
      code: [],
      type: [true, false, false, false, false, false]
    }
  },
  watch: {
    code: {
      deep: true,
      handler(val) {
        this.codeSplit()
        if (val[0]) {
          this.type[1] = true
        }
        if (val[1]) {
          this.type[2] = true
        }
        if (val[2]) {
          this.type[3] = true
        }
        if (val[3]) {
          this.type[4] = true
        }
        if (val[4]) {
          this.type[5] = true
        }
        if (val[5]) {
          this.signIn()
        }
      }
    }
  },
  methods: {
    codeSplit() {
      if (this.code[0].split('').length > 1) {
        var codes = this.code[0].split('')
        this.code[0] = codes[0]
        this.code[1] = codes[1]
        this.code[2] = codes[2]
        this.code[3] = codes[3]
        this.code[4] = codes[4]
        this.code[5] = codes[5]
      }
    },
    next() {
      this.$router.push({
        name: 'Complete'
      })
    },
    back() {
      window.location.reload()
    },
    signIn() {
      this.loading = true
      var code =
        this.code[0].toString() +
        this.code[1].toString() +
        this.code[2].toString() +
        this.code[3].toString() +
        this.code[4].toString() +
        this.code[5].toString()
      var credential = fb.provider.credential(this.verificationId, code)
      fb.auth.signInWithCredential(credential).then(() => {
        this.loading = false
        this.$store.dispatch('getAndSetUser')
        Swal.fire({
          icon: 'success',
          title: "You're in",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.scrollToTop()
          this.$router.push({
            name: 'Complete'
          })
        })
      })
    },
    scrollToTop() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
    }
  }
}
</script>
